const listRegionSelector = '#assignment-resource-list-region';
const statusSelector = '#assignment_resource_status';

export const assignmentResourceEntryKey = (entry) => {
    const resourceId = entry.dataset.assignmentResourceId;
    if (resourceId) return `resource:${resourceId}`;

    const folderId = entry.querySelector('[data-resource-group-id]')?.dataset.resourceGroupId;
    if (folderId) return `folder:${folderId}`;

    return entry.id ? `id:${entry.id}` : null;
};

export const appendUniqueAssignmentResourceEntries = (list, pagination, html) => {
    const template = document.createElement('template');
    template.innerHTML = html || '';

    const existingKeys = new Set(
        Array.from(list.children)
            .filter((entry) => entry !== pagination)
            .map(assignmentResourceEntryKey)
            .filter(Boolean)
    );
    const appendedEntries = [];

    Array.from(template.content.children).forEach((entry) => {
        const key = assignmentResourceEntryKey(entry);
        if (key && existingKeys.has(key)) return;

        pagination.before(entry);
        if (key) existingKeys.add(key);
        appendedEntries.push(entry);
    });

    return appendedEntries;
};

export const focusFirstAssignmentResourceEntry = (entries) => {
    const firstInteractiveElement = entries[0]?.querySelector(
        'button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    firstInteractiveElement?.focus();
};

export const updateAssignmentResourceLiveRegion = (status, message) => {
    if (!status || !message) return;

    // Clearing first ensures assistive technology announces repeated updates.
    status.textContent = '';
    window.requestAnimationFrame(() => {
        if (status.isConnected) status.textContent = message;
    });
};

export const announceAssignmentResourceStatus = (message, container = document) => {
    updateAssignmentResourceLiveRegion(container.querySelector(statusSelector), message);
};

export const initializeAssignmentResourceRows = (container, options = {}) => {
    const {
        refreshSelection = false,
        initializeSorting = false,
        initializeFolders = false
    } = options;
    const roots = Array.isArray(container) ? container : [container || document];

    if (refreshSelection) window.selected_assignments_widget?.();
    if (initializeSorting) window.initializeSort?.();
    roots.forEach((root) => {
        const $root = $(root);
        const $tooltips = $root
            .filter('[data-bs-toggle="tooltip"]')
            .add($root.find('[data-bs-toggle="tooltip"]'));
        const $popovers = $root
            .filter('.empty_folder_info_icon')
            .add($root.find('.empty_folder_info_icon'));
        $tooltips.tooltip();
        $popovers.popover();
    });
    window.assignmentResourceNotifications?.refreshMyAssignmentsNotifications();
    if (initializeFolders) window.initializeAssignmentResourceFolders?.();
};

export const replaceAssignmentResourceList = (html, options = {}) => {
    const currentRegion = document.querySelector(listRegionSelector);
    if (!currentRegion || typeof html !== 'string') return false;

    currentRegion.outerHTML = html;
    const nextRegion = document.querySelector(listRegionSelector);
    if (!nextRegion) return false;

    initializeAssignmentResourceRows(nextRegion, {
        refreshSelection: true,
        initializeSorting: true,
        initializeFolders: true
    });
    window.initializeAssignmentResourcePagination?.();

    if (options.totalCount !== undefined) {
        window.count_search_results?.(options.totalCount);
    }

    const message = options.statusMessage || nextRegion.dataset.statusMessage;
    announceAssignmentResourceStatus(message);
    return true;
};

window.announceAssignmentResourceStatus = announceAssignmentResourceStatus;
window.initializeAssignmentResourceRows = initializeAssignmentResourceRows;
window.replaceAssignmentResourceList = replaceAssignmentResourceList;
